// F-17 (b): tipos de decisión de una pregunta sí/no (Ley 675). La regla que
// decide está en el servidor (backend/src/utils/decision.js); esto es solo el
// texto que ve el staff.
export const DECISIONES = [
  { valor: 'economica', icono: '💰', titulo: 'Económica',
    ejemplos: 'Presupuesto, cuotas, obras, multas',
    regla: 'Cuenta por coeficiente',
    detalle: 'se aprueba con más del 50 % de los coeficientes presentes' },
  { valor: 'no_economica', icono: '🏠', titulo: 'No económica',
    ejemplos: 'Aprobar el acta, dignatarios, convivencia',
    regla: 'Una unidad, un voto',
    detalle: 'se aprueba con más del 50 % de las unidades presentes',
    soloResidencial: true },
  { valor: 'calificada', icono: '⚖️', titulo: 'Calificada 70 %',
    ejemplos: 'Reformar el reglamento, uso de bienes comunes, expensas extraordinarias grandes',
    regla: '70 % de todo el conjunto',
    detalle: 'se aprueba con el 70 % o más de los coeficientes de todo el conjunto (Art. 46)' },
];
export const decisionDe = (valor) => DECISIONES.find(d => d.valor === valor) || null;
